import { ReactNode } from "react";

interface EmptyCellProps {
    children?: ReactNode;
    className?: string;
}

export const EmptyCell: React.FC<EmptyCellProps> = ({ children, className }) => {
    if (children !== undefined && children !== null && children !== "null") {
        return <>{children}</>;
    }
    return <span className={className}>-</span>;
};
